export default __webpack_public_path__ + "static/media/active-message-icon.9ffb15e9.svg";